module.exports = __webpack_public_path__ + "img/box_bonus_last.47bb289e.png";